import { FormFieldTypes } from "../../../data/formFieldType";
import RelatedEvent from "../component/RelatedEvent";
import CommitteeCpdAprrovalTable from "./CommitteeCpdAprrovalTable";

export const CPDEventData = {
    name: "CPDEventData",

    initialState: {
        applicationRun: "New",
        chooseEvent: null,
        relatedEvent: '',
        typeOfEvent: null,
        eventCompetencies: null,
        eventTitle: '',
        eventSynopsis: '',
        eventURL: '',
        registrationURLorEmailAddress: '',
        eventProgrammeFile: '',
        speakersCVSFile: '',
        additionalRemarks: '',
        eventVenue: '',
        eventAddress: '',
        postalCode: '',
        standardOrNonMember: null,
        member: null,
        nameOfRepresentative: '',
        contactNumber: '',
        emailAddress: '',
        nameofAlternateRepresentative: '',
        alternateContactNumber: '',
        alternateEmailAddress: '',
        startDate: '',
        endDate: '',
        startTime: '',
        endTime: '',
        totalContactHours: null,
        cpdPoints: null
    },

    formFields: [
        {
            id: "Type of Application",
            lable: "",
            Field_Name: "Type of Application",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "Type of Application",
            fieldSetting: {
                formTitle: "Type of Application",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left form-title",
            },
        },

        {
            id: "applicationRun",
            label: "Application Run (New/Run)",
            Field_Name: "Application Run (New/Run)",
            fieldType: FormFieldTypes.RADIOBUTTON,
            dataField: "applicationRun",
            fieldSetting: {
                placeholder: "",
                options: [
                    { label: "New", value: "New", isDisable: false, },
                    { label: "Rerun", value: "Rerun", isDisable: false, optionClass: "mr-3" },
                ],
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-lg-12  col-12 mb-4 y-position",
            },
        },
        {
            id: "chooseEvent",
            lable: "Choose Event",
            Field_Name: "Choose Event",
            fieldType: FormFieldTypes.SELECT,
            dataField: "chooseEvent",
            fieldSetting: {
                placeholder: "",
                options: [],
                isDisable: true,
            },
            validation: [],
            style: {
                containerCss: "col-lg-6 col-12 mb-3 d-none",
            },
        },
        {
            id: "relatedEvent",
            lable: "Related Event",
            Field_Name: "Related Event",
            fieldType: FormFieldTypes.INPUT,
            dataField: "relatedEvent",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: true,
            },
            style: {
                containerCss: "col-lg-6 col-12 mb-3 d-none",
            },
        },
        {
            id: "additionalButton",
            fieldType: FormFieldTypes.COMPONENT,
            additionalComponent: <RelatedEvent />,
            style: {
                containerCss: "col-lg-8 mb-2 mt-2 text-left form-title d-none",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "Event Details",
            lable: "",
            Field_Name: "Event Details",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "aEvent Details",
            fieldSetting: {
                formTitle: "Event Details",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left form-title",
            },
        },
        {
            id: "typeOfEvent",
            lable: "Type of Event",
            Field_Name: "Type of Event",
            fieldType: FormFieldTypes.SELECT,
            dataField: "typeOfEvent",
            fieldSetting: {
                placeholder: "",
                options: [],
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-lg-5 col-12 mb-3",
            },
        },
        {
            id: "instructionComponent",
            dataField: "instructionComponent",
            fieldType: FormFieldTypes.COMPONENT,
            additionalComponent: null,
            style: {
                containerCss: "col-md-2 mb-3 mobile-none",
            }
        },
        {
            id: "eventCompetencies",
            lable: "Event Competencies",
            Field_Name: "Event Competencies",
            fieldType: FormFieldTypes.SELECT,
            dataField: "eventCompetencies",
            fieldSetting: {
                placeholder: "",
                options: [],
                isMultiSelect: true,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-lg-5 col-12 mb-3",
            },
        },
        {
            id: "eventTitle",
            lable: "Event Title ",
            Field_Name: "Event Title ",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventTitle",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-9 mb-3",
            },
        },
        {
            id: "eventSynopsis",
            lable: "Event Synopsis",
            Field_Name: "Event Synopsis ",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "eventSynopsis",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "eventURL",
            lable: "Event URL (if applicable)",
            Field_Name: "Event URL (if applicable)",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventURL",
            fieldSetting: {
                placeholder: "",
                options: [],
                isDisable: false,
            },
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "registrationURLorEmailAddress",
            lable: "Registration URL or Email Address",
            Field_Name: "Registration URL or Email Address",
            fieldType: FormFieldTypes.INPUT,
            dataField: "registrationURLorEmailAddress",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "eventProgrammeFile",
            lable: "Event programme/EDM",
            Field_Name: "Event programme/EDM",
            fieldType: FormFieldTypes.FILE,
            dataField: "eventProgrammeFile",
            fieldSetting: {
                placeholder: "",
                isDownloadable: true,
                acceptedFiles: ".pdf, .png, .jpg",
                maxFileSizeInKB: 2048,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "speakersCVSFile",
            lable: "Speakers/CVS",
            Field_Name: "Speakers/CVS",
            fieldType: FormFieldTypes.FILE,
            dataField: "speakersCVSFile",
            fieldSetting: {
                placeholder: "",
                isDownloadable: true,
                acceptedFiles: ".pdf, .png, .jpg",
                maxFileSizeInKB: 2048,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            id: "additionalRemarks",
            lable: "Additional Remarks",
            Field_Name: "Additional Remarks",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "additionalRemarks",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxWords: 100,
                isDisable: false,
            },
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "Location",
            lable: "",
            Field_Name: "Location",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "location",
            fieldSetting: {
                formTitle: "Location",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left title-small",
            },
        },
        {
            id: "eventVenue",
            lable: "Event Venue",
            Field_Name: "EventVenue",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventVenue",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-9 mb-3",
            },
        },
        {
            id: "eventAddress",
            lable: "Event Address",
            Field_Name: "eventAddress",
            fieldType: FormFieldTypes.INPUT,
            dataField: "eventAddress",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-9 mb-3",
            },
        },
        {
            id: "postalCode",
            lable: "Postal Code",
            Field_Name: "postalCode",
            fieldType: FormFieldTypes.INPUT,
            dataField: "postalCode",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-9 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "fees",
            lable: "",
            Field_Name: "Fees",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "fees",
            fieldSetting: {
                formTitle: "Fees",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left title-small",
            },
        },
        {
            id: "standardOrNonMember",
            lable: "Standard/Non-member",
            Field_Name: "Standard/Non-member",
            fieldType: FormFieldTypes.INPUT,
            dataField: "standardOrNonMember",
            fieldSetting: {
                placeholder: "$",
                allowSpace: true,
                maskFormat: "$ ",
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-7 mb-3",
            },
        },
        {
            id: "member",
            lable: "Member",
            Field_Name: "Member",
            fieldType: FormFieldTypes.INPUT,
            dataField: "member",
            fieldSetting: {
                placeholder: "$",
                allowSpace: true,
                maskFormat: "$ ",
            },
            style: {
                containerCss: "col-md-7 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "OrganisationRepresentativeDetails",
            lable: "",
            Field_Name: "OrganisationRepresentativeDetails",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "OrganisationRepresentativeDetails",
            fieldSetting: {
                formTitle: "Organisation Representative Details",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left title-small",
            },
        },

        {
            id: "nameOfRepresentative",
            lable: "Name of Representative",
            Field_Name: "Name of Representative",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameOfRepresentative",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "contactNumber",
            lable: "Contact Number",
            Field_Name: "ContactNumber",
            fieldType: FormFieldTypes.INPUT,
            dataField: "contactNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "emailAddress",
            lable: "Email Address",
            Field_Name: "EmailAddress",
            fieldType: FormFieldTypes.INPUT,
            dataField: "emailAddress",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-border pl-0 pr-0 mb-3",
            },
        },
        {
            id: "nameofAlternateRepresentative",
            lable: "Name of Alternate Representative",
            Field_Name: "Name of Alternate Representative",
            fieldType: FormFieldTypes.INPUT,
            dataField: "nameofAlternateRepresentative",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            //   validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "alternateContactNumber",
            lable: "Contact Number",
            Field_Name: "Contact Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "alternateContactNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            //   validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            id: "alternateEmailAddress",
            lable: "Email Address",
            Field_Name: "Email Address",
            fieldType: FormFieldTypes.INPUT,
            dataField: "alternateEmailAddress",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            //   validation: [{ type: "require" }],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "Schedule",
            lable: "",
            Field_Name: "Schedule",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "Schedule",
            fieldSetting: {
                formTitle: "Schedule",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left title-small",
            },
        },
        {
            id: "startDate",
            lable: "Start Date",
            Field_Name: "startDate",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "startDate",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space mb-3"
            }
        },
        {
            id: "endDate",
            lable: "End Date",
            Field_Name: "End Date",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "endDate",
            fieldSetting: {
                placeholder: "",
                options: []
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space mb-3"
            }
        },
        {
            id: "startTime",
            lable: "Start Time (for single day activity)",
            Field_Name: "Start Time (for single day activity)",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "startTime",
            fieldSetting: {
                placeholder: "",
                // options: [],
                isTime: true
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space mb-3"
            }
        },
        {
            id: "endTime",
            lable: "End Time (for single day activity)",
            Field_Name: "End Time (for single day activity)",
            fieldType: FormFieldTypes.DATEPICKER,
            dataField: "endTime",
            fieldSetting: {
                placeholder: "",
                // options: [],
                isTime: true
            },
            // validation: [{ type: "require" }],
            style: {
                containerCss: "col-12 col-sm-12 col-md-6 col-xl-6 col-lg-6 input-margin-space mb-3"
            }
        },
        {
            id: "totalContactHours",
            lable: "Total Contact Hours",
            Field_Name: "Total Contact Hours",
            fieldType: FormFieldTypes.INPUT,
            dataField: "totalContactHours",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
        {
            fieldType: FormFieldTypes.SEPARATOR,
            style: {
                containerCss: "separation-line pl-0 pr-0",
            },
        },
        {
            id: "Proposed CPD Points",
            lable: "",
            Field_Name: "Proposed CPD Points",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "Proposed CPD Points",
            fieldSetting: {
                formTitle: "Proposed CPD Points",
            },
            style: {
                containerCss: "col-lg-12 mb-3 text-left title-small",
            },
        },
        {
            id: "cpdPoints",
            lable: "CPD Points",
            Field_Name: "CPD Points",
            fieldType: FormFieldTypes.NUMERIC,
            dataField: "cpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-6 mb-3",
            },
        },
    ],

    formSetting: {
        isViewOnly: false,
    },
};

export const CommitteeCpdApprovalData = {
    name: "CommitteeCpdApprovalData",

    initialState: {
        committeApproval: "",
        internalComments: "",
        finalCpdPoints: null
    },

    formFields: [
        {
            id: "applicantOrganisationProfile",
            lable: "",
            Field_Name: "decisionCard-CommitteeApproval",
            fieldType: FormFieldTypes.MAINFORMTITLE,
            dataField: "decisionCard-CommitteeApproval",
            fieldSetting: {
                formTitle: "Decision Card - Committee Approval",
            },
            style: {
                containerCss: "col-lg-12 mb-2 text-left form-title",
            },
        },
        {
            id: "committeApproval",
            fieldType: FormFieldTypes.COMPONENT,
            additionalComponent: <CommitteeCpdAprrovalTable />,
            style: {
                containerCss: "col-lg-8 mb-2 text-left form-title",
            },
        },
        {
            id: "internalComments",
            lable: "Comments",
            Field_Name: "Internal Comments",
            fieldType: FormFieldTypes.TEXTAREA,
            dataField: "internalComments",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                maxLength: 500,
                isDisable: true,
            },
            style: {
                containerCss: "col-md-12",
            },
        },
        {
            id: "finalCpdPoints",
            lable: "Final CPD Point",
            Field_Name: "Final CPD Point",
            fieldType: FormFieldTypes.NUMERIC,
            dataField: "finalCpdPoints",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
                isDisable: false,
            },
            validation: [ { type: "require" } ],
            style: {
                containerCss: "col-md-12 mb-3",
            },
        },
    ],

    formSetting: {
        isViewOnly: false,
    },
};